import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link } from '../general/util/Links'
import Image from '../general/util/Image'
import HTML from '@otavamedia/om-component-library/lib/util/HTML'
import missingImage from '../../assets/pictures/missing-image.png'
import { ErrorPlaceholderBox, withErrorBoundary } from '../general/util/ErrorBoundaries'
import { IMAGE_SIZE } from '@otavamedia/om-component-library/lib/entities/ImageModel'
import './ArticleItem.scss'
import DateField from '../general/widgets/DateField'
import diff from 'date-fns/difference_in_days'

class ArticleItem extends Component {
  static propTypes = {
    article: PropTypes.object,
    size: PropTypes.string.isRequired,
    noImage: PropTypes.bool,
    backgroundColour: PropTypes.string,
    capitalizeTitle: PropTypes.bool,
    showDate: PropTypes.bool,
    latest: PropTypes.string,
    equation: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.bool,
    ]),
    magazine: PropTypes.string,
    related: PropTypes.array,
    imageLocation: PropTypes.string,
    isPrimary: PropTypes.bool,
  }

  renderVignetteAndTopic = (vignette, topic, date, isLatest, isNew) => {
    if (vignette && topic) {
      return (
        <div styleName="meta-row">
          <header>
            <div styleName="meta-row-topic"><HTML>{vignette}</HTML>&nbsp;</div>
            <div styleName={this.props.isPrimary ? 'meta-row-topic light capitalized' : 'meta-row-topic light'}><HTML>{topic}</HTML></div>
            {date ? <div styleName="meta-row-topic light">&nbsp;<DateField date={date} dateOnly/></div> : null}
            {isNew ? <div styleName="latest">Uusi</div> : null}
          </header>
        </div>
      )
    } else if (vignette && !topic) {
      return <div styleName="meta-row">
        <header styleName="meta-row-topic">
          <HTML>{vignette}</HTML>
          {date ? <div styleName="meta-row-topic light">&nbsp;<DateField date={date} dateOnly/></div> : null}
          {isNew ? <div styleName="latest">Uusi</div> : null}
        </header>
      </div>
    } else {
      return (date || isNew)
        ? <div styleName="meta-row">
          <header>
            {date ? <div styleName="meta-row-topic light"><DateField date={date} dateOnly/></div> : null}
            {isNew ? <div styleName="latest">Uusi</div> : null}
          </header>
        </div>
        : null
    }
  }

  renderRelatedVignetteAndTopic = (vignette, topic) => {
    if (vignette && topic) {
      return <header><HTML>{vignette}: {topic} &mdash; </HTML></header>
    } else if (vignette && !topic) {
      return <header><HTML>{vignette}: </HTML></header>
    } else {
      return null
    }
  }

  renderImage = () => {
    const { article, size } = this.props
    return (article.image && article.image.src)
      ? <Image data={article.image} size={size === 'sm' ? IMAGE_SIZE.MEDIUM : IMAGE_SIZE.LARGE}
        sizes={size === 'sm' ? '100px' : '(max-width: 768px) 50vw, 100vw'}/>
      : <img src={missingImage} alt="Kuvaa ei löytynyt"/>
  }

  renderNormalTitle = () => {
    const { article, capitalizeTitle } = this.props
    return <h3 styleName={`${capitalizeTitle ? 'capitalized' : ''}`}><HTML>{article.title}</HTML></h3>
  }

  renderEquationTitle = (date, isLatest, isNew) => {
    const { equation } = this.props
    return <Fragment>
      <div styleName="topic-header">
        Puheenaihe
        {date ? <div styleName="light">&nbsp;|&#32;<DateField date={date} dateOnly/></div> : null}
        {isNew ? <div styleName="latest">Uusi</div> : null}
      </div>
      <h3 styleName="with-equation">
        <div styleName="equation">
          {equation.map((part, index) => {
            return <span key={`equation-part-${index}`} styleName={`${part.isOperator ? 'operator' : 'operand'}`}>{part.part} </span>
          })}
        </div>
      </h3>
    </Fragment>
  }

  renderTileContents = () => {
    const { article, size, equation, showDate, latest } = this.props
    const isLatest = showDate && latest && article.date && latest === article.date
    const isNew = showDate && latest && article.date && diff(new Date(), article.date) < 8
    return (
      <Fragment>
        {!equation && this.renderVignetteAndTopic(article.vignette, article.topic, showDate ? article.date : null, isLatest, isNew)}
        {equation
          ? this.renderEquationTitle(showDate ? article.date : null, isLatest, isNew)
          : this.renderNormalTitle()
        }
        {size !== 'sm' && (article.description || article.excerpt)
          ? <div styleName="ingress">
            <HTML>{article.description || article.excerpt}</HTML>
          </div>
          : null
        }
      </Fragment>
    )
  }

  renderWithoutImage = () => {
    const { article, size, backgroundColour } = this.props
    return (
      <Fragment>
        <div styleName={`article-content-without-image ${backgroundColour ? `background-${backgroundColour}` : ''}`}>
          {this.renderTileContents(article, size)}
        </div>
      </Fragment>
    )
  }

  renderWithImage = () => {
    const { article, size, backgroundColour, imageLocation } = this.props
    return size === 'md' && imageLocation === 'right'
      ? (
        <Fragment>
          <div styleName={`article-content ${backgroundColour ? `background-${backgroundColour}` : ''}`}>
            {this.renderTileContents(article, size)}
          </div>
          <div styleName="item-image">
            {this.renderImage()}
          </div>
        </Fragment>
      )
      : (
        <Fragment>
          <div styleName="item-image">
            {this.renderImage()}
          </div>
          <div styleName={`article-content ${backgroundColour ? `background-${backgroundColour}` : ''}`}>
            {this.renderTileContents(article, size)}
          </div>
        </Fragment>
      )
  }

  render () {
    const { article, size, noImage, equation, related } = this.props
    const isAd = !!article && article.type === 'om_ad_article'

    return article
      ? (
        <div styleName={`${size}`} key={article.id}>
          {article.link
            ? (
              <Link to={article}>
                <article styleName={`article-list-item ${isAd ? 'is-ad' : ''}`}>
                  {noImage || equation
                    ? this.renderWithoutImage()
                    : this.renderWithImage()
                  }
                </article>
              </Link>
            )
            : (
              <article styleName={`article-list-item ${isAd ? 'is-ad' : ''} disabled`}>
                {noImage || equation
                  ? this.renderWithoutImage()
                  : this.renderWithImage()
                }
              </article>
            )}
          {related && related.length
            ? (
              <div styleName="related-container">
                <span>Lue myös:</span>
                <ul>
                  {related.map((item, index) => {
                    return (
                      <li key={`related-article-${index}`}>
                        <Link to={{ link: item.post.link }}>
                          {this.renderRelatedVignetteAndTopic(item.post.vignette, item.post.topic)}{item.post.title}
                        </Link>
                      </li>
                    )
                  })}
                </ul>
              </div>
            )
            : null}
        </div>
      )
      : null
  }
}

export default withErrorBoundary(
  ArticleItem,
  ErrorPlaceholderBox('Artikkelia ei saatu ladattua'),
)
